var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMedida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10579 3.00438C2.62804 2.45671 3.17582 53.4001 8.10579 53.4C13.0358 53.3999 50.8325 32.5843 50.8325 28.2022C50.8325 23.82 13.5835 3.55206 8.10579 3.00438Z",
    fill: "#E9EFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8253 4.16831L16.171 22.8227C15.7316 23.262 15.7316 23.9743 16.171 24.4137L23.58 31.8227C24.0194 32.262 24.7317 32.262 25.171 31.8227L43.8254 13.1683C44.2647 12.729 44.2647 12.0167 43.8254 11.5774L36.4163 4.16831C35.977 3.72897 35.2647 3.72897 34.8253 4.16831Z",
    stroke: "url(#paint0_linear_5_137)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5625 8.4375L35.0625 12.9375",
    stroke: "url(#paint1_linear_5_137)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5L30 18",
    stroke: "url(#paint2_linear_5_137)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 18.5625L24.9375 23.0625",
    stroke: "url(#paint3_linear_5_137)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_137",
    x1: 19.8755,
    y1: 28.1182,
    x2: 40.1209,
    y2: 7.87283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_137",
    x1: 30.5625,
    y1: 10.6875,
    x2: 35.0625,
    y2: 10.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_137",
    x1: 25.5,
    y1: 15.75,
    x2: 30,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_137",
    x1: 20.4375,
    y1: 20.8125,
    x2: 24.9375,
    y2: 20.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedida);
export default __webpack_public_path__ + "static/media/icon-medida.92b332c0351fffad157a94c5075935c6.svg";
export { ForwardRef as ReactComponent };